import { render } from "./crudPopUp.vue?vue&type=template&id=0f250ccb"
import script from "./crudPopUp.vue?vue&type=script&lang=js"
export * from "./crudPopUp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__